<template>
	<div
		class="question-summary"
		ref="summary"
	>
		<div class="summary-container">
			<div class="section-question">{{ mainText }}</div>
			<div
				class="question-info"
				v-html="summaryText"
			></div>
			<div
				v-seen="{ callback: setDisable, options: { threshold: 0.01 } }"
				ref="bottomMarker"
				class="bottom-marker"
			></div>
		</div>
		<div class="summary-fixed-bottom">
			<div class="summary-action">
				<button
					class="button"
					v-for="answer in data.question.getAnswers()"
					:key="answer.label"
					:style="{
						background: theme[answer.style.background],
						color: theme[answer.style.text],
					}"
					@click="answer.actions(null, [], data.question, toggleLoading, saveApplicationAction)"
					:disabled="buttonsDisabled"
				>
					{{ data.question.getLocalizationDisplay(answer.label, data.language) }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import ENUMS from '@core/classes/Enums';
	import LogRocket from 'logrocket';
	import IntersectionObserverDirective from '@core/directives/intersection-observer-directive';
	import { redirectToCustomerPortal } from '@core/helpers/Customer/customer-helper';

	export default {
		name: 'QuestionSummary',
		props: ['theme', 'data', 'questionKey', 'toggleLoading', 'saveApplicationAction'],
		data() {
			return {
				mainText: null,
				summaryText: '',
				buttonsDisabled: false,
			};
		},
		computed: {
			ENUMS() {
				return ENUMS;
			},
		},
		created() {
			this.init();
			this.$watch(
				() => this.data.language,
				newValue => {
					this.data.question.customerApp().quoteAppData.changeLanguage(newValue);
					this.init();
				},
				{ deep: true },
			);

			if (this.data.question.redirectToCustomerPortal == true || this.data.question.isEndOfApp == true) {
				setTimeout(async () => {
					const linkForRedirect = await redirectToCustomerPortal(this.data.application.customerId);
					window.location.href = linkForRedirect;
				}, 3500);
			}
		},
		methods: {
			init() {
				const creditApp = this.data.question.customerApp();
				this.summaryText = '';
				this.data.question.getQuestion().forEach((q, index) => {
					if (index == 0) {
						this.mainText = q;
					} else {
						this.summaryText += q;
					}
				});
				LogRocket.track('Customer_App_Section_Ended', {});
			},
			setDisable() {
				this.buttonsDisabled = false;
			},
		},
		directives: {
			seen: IntersectionObserverDirective,
		},
		components: {},
	};
</script>

<style>
	.loading .spinner-container {
		background: white;
	}

	.bottom-marker {
		height: 1px;
		width: 100%;
		padding-bottom: 50px;
	}
</style>
